import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Flame, Trophy, Users, Crown, Gift } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Avatar } from "@/components/Avatar";

export const StreakLeaderboard = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/client/me/leaderboard").then((r) => setD(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const toggle = async (optIn) => {
    setBusy(true);
    try { await api.post("/client/me/leaderboard", { optIn }); toast.success(optIn ? "You're on the board — go get that streak" : "You've left the leaderboard"); await load(); } catch (ex) { toast.error(errMsg(ex)); }
    setBusy(false);
  };
  if (!d) return null;
  return (
    <div className="panel lb" data-testid="streak-leaderboard">
      <div className="ph">
        <h3><Trophy size={15} /> Community streaks</h3>
        <span className="ss"><Users size={12} /> {d.participants} on the board</span>
      </div>
      {d.prize?.prize && (
        <div className="lb-prize" data-testid="leaderboard-prize">
          <span className="gift"><Gift size={18} strokeWidth={2.4} /></span>
          <div><small>{d.prize.month} prize · longest streak wins</small><b>{d.prize.prize}</b>{d.prize.note && <p>{d.prize.note}</p>}</div>
        </div>
      )}
      {d.prize?.lastWinner && (
        <div className="lb-last" data-testid="leaderboard-last-winner"><Crown size={13} strokeWidth={2.6} /> {d.prize.lastWinner.label} champion: <b>{d.prize.lastWinner.name}</b> · {d.prize.lastWinner.streak}-week streak{d.prize.lastWinner.prize ? ` · won ${d.prize.lastWinner.prize}` : ""}</div>
      )}
      {!d.optIn ? (
        <div className="lb-optin" data-testid="leaderboard-optin">
          <p>See how your streak stacks up against the rest of the crew. Only your first name and streak are shown — you can leave any time.</p>
          <button type="button" className="btn" disabled={busy} onClick={() => toggle(true)} data-testid="leaderboard-join">Join the leaderboard</button>
        </div>
      ) : (
        <>
          <div className="lb-rows">
            {d.rows.map((r) => (
              <div className={`lb-row ${r.isMe ? "me" : ""} ${r.rank === 1 ? "top" : ""}`} key={r.clientId} data-testid={`leaderboard-row-${r.rank}`}>
                <span className="rank num">{r.rank === 1 ? <Crown size={14} strokeWidth={2.6} /> : r.rank}</span>
                <Avatar client={{ id: r.clientId, photoKey: r.photoKey, name: r.name }} size={28} radius={8} />
                <b className="nm">{r.name}{r.isMe && <em> · you</em>}</b>
                <span className="ss best">best {r.best}</span>
                <span className={`flame ${r.streak >= 4 ? "hot" : r.streak >= 1 ? "warm" : "cold"}`}><Flame size={14} strokeWidth={2.4} fill={r.streak ? "currentColor" : "none"} /><b className="num">{r.streak}</b><small>wk</small></span>
              </div>
            ))}
            {d.me && d.me.rank > d.rows.length && (
              <div className="lb-row me" data-testid="leaderboard-row-me"><span className="rank num">{d.me.rank}</span><b className="nm">You</b><span className={`flame ${d.me.streak ? "warm" : "cold"}`}><Flame size={14} /><b className="num">{d.me.streak}</b><small>wk</small></span></div>
            )}
          </div>
          <button type="button" className="lb-leave" disabled={busy} onClick={() => toggle(false)} data-testid="leaderboard-leave">Leave leaderboard</button>
        </>
      )}
    </div>
  );
};
